<template>
    <v-card>
        <v-card-title>Comissões</v-card-title>
        <v-simple-table>
            <template v-slot:default>
                <thead>
                    <tr>
                        <th class="text-left">Cliente</th>
                        <th class="text-left">Plano</th>
                        <th class="text-left">Pgto. Cliente</th>
                        <th class="text-left">Valor</th>
                        <th class="text-left">Comissão</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in orderedItems" :key="item.id">
                        <td>
                            {{ itemName(item) }}
                        </td>
                        <td>{{ item.plan.name }}</td>
                        <td>
                            {{ item.period.formattedPaidAt }}
                        </td>
                        <td>
                            {{ item.formattedBaseValue }}
                        </td>
                        <td>{{ item.formattedValue }}</td>
                    </tr>
                    <tr>
                        <td colspan="4">
                            <strong>Total</strong>
                        </td>
                        <td>
                            <strong>{{ $n(total, 'currency') }}</strong>
                        </td>
                    </tr>
                </tbody>
            </template>
        </v-simple-table>
    </v-card>
</template>
<script>
export default {
    props: {
        items: {
            required: true,
        },
    },

    methods: {
        itemName(item) {
            return item.customer && item.customer.trade_name
                ? item.customer.trade_name
                : item.previous_commission && item.previous_commission.reference
                ? `Comissão de ${item.previous_commission.reference}`
                : item.certificate_request && item.certificate_request.customer
                ? `Certificado digital ${item.certificate_request.customer.trade_name}`
                : ''
        },
    },

    computed: {
        orderedItems() {
            if (!this.items.length) return
            const items = this.items
            return items.sort((a, b) => {
                const aName = this.itemName(a)
                const bName = this.itemName(b)
                aName.localeCompare(bName)
            })
        },

        total() {
            if (!this.items.length) return 0

            const total = this.items.reduce(
                (sum, item) => (sum += parseFloat(item.value)),
                0,
            )

            return total
        },
    },
}
</script>
